export * from './service-call-create.component';
export * from './service-call-create.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/service-call/service-call-create/index.ts